
<div class="container-fluid p-0 d-lg-block">
    <footer class="flex-wrap justify-content-center px-5 py-5 row gap-4 gap-lg-0 bg-white">

        <div class="col-12 col-lg-6 p-0" *ngIf="stores.app_store || stores.play_store">
            <div class="align-items-center d-flex flex-column gap-3">
                <div>
                    <h1 class="fs-6 m-0">{{ "shop_on_the_go" | translate: "footer" }}</h1>
                </div>
                <div class="d-flex gap-2">
                    <a 
                    *ngIf="stores.app_store"
                    href="{{ stores.app_store }}"
                    target="_blank"
                    class="d-flex align-items-center mb-1 link-dark text-decoration-none"
                    >
                        <img src="../../../assets/icon/app-store.svg" class="icom-w-style" style="cursor: pointer;">
                    </a>

                    <a 
                    *ngIf="stores.play_store"
                    href="{{ stores.play_store }}"
                    target="_blank"
                    class="d-flex align-items-center mb-1 link-dark text-decoration-none"
                    >
                        <img src="../../../assets/icon/google-play.svg" class="icom-w-style" style="cursor: pointer;">
                    </a>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-6 p-0">
            <div class="align-items-center d-flex flex-column gap-3">
                <div>
                    <h1 class="fs-6 m-0">{{ "social_title" | translate: "footer" }}</h1>
                </div>
                <div class="d-flex gap-2">
                    <ng-container  *ngFor="let social of socials">
                        <a href="{{ social?.url }}" target="_blank" *ngIf="social?.url" class="d-flex justify-content-center align-item-center p-2 rounded-circle social-box">
                          <img class="footer-logos" src="{{ social?.icon }}" alt="{{ social?.socialType }}" width="20" height="20">
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>

    </footer>
</div>
